// Image URL transformer + srcSet builder.
// Emits `?w=<width>&q=<quality>&fmt=webp` for our Emergent Object Storage proxy
// (`/api/files/...`) and Unsplash CDN. WebP gives ~90-99% payload reduction vs.
// the original PNG/JPG, and is supported by every modern browser (>96%).

const isFilesUrl = (url) => /\/api\/files\//.test(url);
const isUnsplash = (url) => /images\.unsplash\.com/.test(url);

/**
 * Return a single transformed URL at a specific width.
 */
export const imgUrl = (src, width, opts = {}) => {
  if (!src) return src;
  const { quality = 80, webp = true } = opts;

  if (isFilesUrl(src)) {
    const sep = src.includes("?") ? "&" : "?";
    const parts = [`w=${width}`, `q=${quality}`];
    if (webp) parts.push("fmt=webp");
    return `${src}${sep}${parts.join("&")}`;
  }

  if (isUnsplash(src)) {
    const [base, query = ""] = src.split("?");
    const clean = query
      .split("&")
      .filter((p) => p && !/^(w|q|fm|auto)=/.test(p))
      .join("&");
    const parts = ["auto=format", `w=${width}`, `q=${quality}`];
    if (webp) parts.push("fm=webp");
    const finalQuery = [clean, ...parts].filter(Boolean).join("&");
    return `${base}?${finalQuery}`;
  }

  return src;
};

/**
 * Build a srcSet string for responsive delivery.
 */
export const imgSrcSet = (src, widths = [320, 480, 640, 800, 1200], opts = {}) => {
  if (!src) return undefined;
  if (!isFilesUrl(src) && !isUnsplash(src)) return undefined;
  return widths.map((w) => `${imgUrl(src, w, opts)} ${w}w`).join(", ");
};
